import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { finalize } from "rxjs/operators";
import { AuthenticationService } from "../../../../core/authentication/authentication.service";
import { DynamicFormComponent } from "../../../../shared/components/dynamic-form/dynamic-form.component";
import { NotificationService } from "../../../../shared/components/notification/notification.service";
import { UserInfo } from "../../../../shared/types/user-info";
import { MaintenanceProviderService } from "../maintenance-provider.service";
import { MaintenanceProvider } from "../maintenance-provider.types";
import { CreateMaintenanceProviderService, ICreateMaintenanceForm } from "./create-maintenance-provider.service";

@Component({
  selector: "app-create-maintenance-provider",
  templateUrl: "./create-maintenance-provider.component.html",
  styleUrls: ["./create-maintenance-provider.component.css"],
  providers: [CreateMaintenanceProviderService],
})
export class CreateMaintenanceProviderComponent implements OnInit {
  @ViewChild(DynamicFormComponent) dynamicForm: DynamicFormComponent;

  currentUser: UserInfo;
  createLocationsForm: FormGroup;
  questions: any;

  constructor(
    public location: Location,
    private router: Router,
    private configsService: MaintenanceProviderService,
    private questionsService: CreateMaintenanceProviderService,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  ngOnInit(): void {
    this.questionsService.generateQuestions({}).subscribe((qs) => {
      this.questions = qs;
    });
  }

  goBack(): void {
    this.location.back();
  }

  onSubmit(values: ICreateMaintenanceForm): void {
    this.configsService
      .createMaintenanceProvider({ ...values })
      .pipe(finalize(() => this.dynamicForm.enable()))
      .subscribe(
        (mp: MaintenanceProvider) => {
          this.notificationService.success("Maintenance provider successfully created");
          this.router.navigate([`/maintenance-providers/${mp.id}`]);
        },
        (error) => {
          this.notificationService.error(error ?? "Could not create maintenance provider");
        },
      );
  }
}
